module.exports = __webpack_public_path__ + "static/media/Asgard-finance_THOR.2b1c99db.png";